import { render, staticRenderFns } from "./HDateAnswer.vue?vue&type=template&id=200dc971&"
import script from "./HDateAnswer.vue?vue&type=script&lang=js&"
export * from "./HDateAnswer.vue?vue&type=script&lang=js&"
import style0 from "./HDateAnswer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports